import { publicLinksAdminRepository } from '@infra/supabase/repositories/SupabasePublicLinksAdminRepository';

export const listPublicLinksAdmin = publicLinksAdminRepository.list;
export const listPublicLinkPipelines = publicLinksAdminRepository.listPipelines;
export const createPublicLinkAdmin = publicLinksAdminRepository.create;
export const revokePublicLinkAdmin = publicLinksAdminRepository.revoke;
export type {
  PublicLinkTipo,
  PublicLinkAdminRow,
  PublicLinkPipeline,
  PublicLinkCreated,
} from '@infra/supabase/repositories/SupabasePublicLinksAdminRepository';
